import React from "react";
import "./SixLinkButtonsPage.css";
import Logo from "../../../assets/images/logo/jsa_logo-removebg-preview.png";
import logoJsaAgri from "../../../assets/images/logo/JsaAgri-logo-1.webp";
import logoJncw from "../../../assets/images/logo/JNC LOGO.png";
import logoJsasiddha from "../../../assets/images/logo/JsaSiddha-png.png";
import logoPharmacy from "../../../assets/images/logo/JSA Pharmacy Logo.png";
import logoNursing from "../../../assets/images/logo/JSA Medical College Logo_page-0001.jpg";
import GoogleFormStyled from "./inputform";

export default function SixLinkButtonsPage() {
  const links = [
    // { title: 'JSA College of Agriculture and Technology ', url: 'https://jsaagri.in/' },
    // { title: 'Jawaharlal Nehru College for Women (Arts & Science)', url: 'https://www.jncw.in/' },
    // { title: 'JSA Medical College for Siddha and Research Centre', url: 'https://jsasiddha.in/courses' },
    // { title: 'JSA Pharmacy College of Medical Science', url: '' },
    // { title: 'JSA Nursing College of Medical Science', url: ''},
    // { title: '', url: 'https://example.com/six' },
    {
      title: "JSA College of Agriculture and Technology",
      url: "https://docs.google.com/forms/d/e/1FAIpQLSeidkM7u85otmU0UH0gpsSuzeHQj4muTKIO6tq06SX7Tpjyng/viewform?usp=publish-editor",
      logo: logoJsaAgri,
    },
    {
      title: "Jawaharlal Nehru College for Women (Arts & Science)",
      url: "https://www.jncw.in/",
      logo: logoJncw,
    },
    {
      title: "JSA Medical College for Siddha and Research Centre",
      url: "https://jsasiddha.in/courses",
      logo: logoJsasiddha,
    },
    {
      title: "JSA Pharmacy College of Medical Science  2026-2027",
      url: "",
      logo: logoPharmacy,
    },
    {
      title: "JSA Nursing College of Medical Science  2026-2027",
      url: "",
      logo: logoNursing,
    },
  ];
  const handleRipple = (e) => {
  const button = e.currentTarget;
  const rect = button.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  button.style.setProperty("--x", `${x}px`);
  button.style.setProperty("--y", `${y}px`);
};


  return (
    // <div className="container py-5 text-center">
    //   <h1 className="mb-4 fw-bold">JSA Group Of Institutions</h1>
    //   <p className="text-muted mb-5">Admission Enquiry Please click here 👇 </p>

    //   <div className="row g-4 justify-content-center">
    //     {links.map((link, i) => (
    //       <div className="col-6 col-md-4 col-lg-3" key={i}>
    //         <a
    //           href={link.url}
    //           target="_blank"
    //           rel="noopener noreferrer"
    //           className="btn btn-outline-primary w-100 py-4 custom-btn"
    //         >
    //           {link.title}
    //         </a>
    //       </div>
    //     ))}
    //   </div>
    // </div>
    <div className="hero-section py-5 text-center">
      <div className="container">
      
   <img
  src={Logo}
  alt="Logo"
  className="main-logo"
/>

        <h1 className="mb-4 fw-bold  text-gradient">
          JSA Group Of Institutions
        </h1>
        <p className="text-muted mb-5 fs-5">
          For college details and admission enquiries, please click here. 👇
        </p>

      {/* <div className="row g-4">
  {links.map((item, index) => (
    <div className="col-12 col-md-6 col-lg-4" key={index}>
      <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
        <div className="card custom-card text-center">
          <img src={item.logo} className="card-img-top card-logo" alt={item.title} />

          <div className="card-body">
            <h5 className="card-title">{item.title}</h5>
          </div>
        </div>
      </a>
    </div>
  ))}
</div> */}
{/* <div className="row g-4">
  {links.map((item, index) => (
    <div className="col-12 col-md-6 col-lg-4" key={index}>

      <div className="card custom-card text-center">

        <img src={item.logo} className="card-logo" alt={item.title} />

        <h5 className="card-title">{item.title}</h5>

       <a
  href={item.url}
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-primary mt-3"
  onClick={handleRipple}
>
  Click Here
</a>


      </div>

    </div>
  ))}
</div> */}
<div className="row g-4">
  {links.map((item, index) => (
    <div className="col-12 col-md-6 col-lg-4" key={index}>
      <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
        <div className="card custom-card text-center">
          <img src={item.logo} className="card-logo" alt={item.title} />

          <h5 className="card-title">{item.title}</h5>

          <button
            className="btn btn-primary mt-3"
            onClick={(e) => {
              const rect = e.target.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;

              e.target.style.setProperty("--x", `${x}px`);
              e.target.style.setProperty("--y", `${y}px`);

              e.target.classList.add("ripple-effect");

              setTimeout(() => {
                e.target.classList.remove("ripple-effect");
              }, 500);
            }}
          >
            Click Here
          </button>
        </div>
      </a>
    </div>
  ))}
</div>




      </div>
      
    </div>
  );
}
